module.exports = __webpack_public_path__ + "static/media/credit-card_visa.2eee1737.svg";